import { render, staticRenderFns } from "./ShearPlate.vue?vue&type=template&id=14022ab8&scoped=true"
import script from "./ShearPlate.vue?vue&type=script&lang=js"
export * from "./ShearPlate.vue?vue&type=script&lang=js"
import style0 from "./ShearPlate.vue?vue&type=style&index=0&id=14022ab8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14022ab8",
  null
  
)

export default component.exports